import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-brand-primary via-blue-800 to-brand-secondary min-h-screen flex items-center">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23ffffff%22%20fill-opacity%3D%220.1%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%222%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')]"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-white">
            <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium mb-6">
              <Icon name="Shield" size={16} className="mr-2" />
              Strategic Independence
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight">
              Own Your AI Destiny,
              <span className="text-brand-accent"> Don't Rent It</span>
            </h1>
            
            <p className="text-xl lg:text-2xl text-blue-100 mb-8 leading-relaxed">
              Stop paying forever for what you could own once. Open-source AI isn't just cost-effective—it's your path to true competitive advantage and technological sovereignty.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button
                variant="default"
                size="lg"
                className="bg-brand-accent hover:bg-brand-accent/90 text-gray-900"
                iconName="Calculator"
                iconPosition="left"
              >
                Calculate Your Savings
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white hover:text-brand-primary"
                iconName="Play"
                iconPosition="left"
              >
                Watch Success Stories
              </Button>
            </div>

            {/* Key Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-brand-accent">87%</div>
                <div className="text-sm text-blue-200">Cost Reduction</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-brand-accent">3x</div>
                <div className="text-sm text-blue-200">Faster Innovation</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-brand-accent">100%</div>
                <div className="text-sm text-blue-200">Data Control</div>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <div className="space-y-6">
                <div className="flex items-center justify-between">
                  <span className="text-white font-medium">Proprietary AI Cost</span>
                  <span className="text-red-400 font-bold">$2.4M/year</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-white font-medium">Open-Source AI Cost</span>
                  <span className="text-green-400 font-bold">$312K/year</span>
                </div>
                <div className="border-t border-white/20 pt-4">
                  <div className="flex items-center justify-between">
                    <span className="text-white font-bold">Annual Savings</span>
                    <span className="text-brand-accent font-bold text-xl">$2.1M</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-16 h-16 bg-brand-accent rounded-full flex items-center justify-center">
              <Icon name="TrendingUp" size={24} className="text-gray-900" />
            </div>
            <div className="absolute -bottom-4 -left-4 w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
              <Icon name="Check" size={16} className="text-white" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;